<template>
    <div id="WorkOrderList">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
      <template v-if="workOrderVal != undefined">
        <div class="bg-white data-table">
            <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange" :moduleName="'listWorkOrders'" :position="'top'">
            </custom-pagination>
            <vue-good-table
              id="listWorkTbl"
              ref="listWorkOrderTable"
              mode="remote"
              title="Work Orders"
              @on-page-change="onPageChange"
              @on-selected-rows-change="selectionChanged"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              @on-sort-change="onSortChange"
              :totalRows="totalRecords"
              :columns="columns"
              :rows="rows"
              :pagination-options="{
                                    enabled: (totalRecords > serverParams.perPage ? true:false),
                                    position: 'bottom',
                                    perPage: perPage,
                                    perPageDropdown:dropDownPerPage,
                                    dropdownAllowAll: false,
                                }"
              :select-options="{
                                enabled: work_order_value,
                                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                selectionInfoClass: 'custom-class',
                                selectionText: 'rows selected',
                                clearSelectionText: 'clear',
                                }"
              :search-options="{
                                enabled: false,
                                }">

              <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                <div :key="key">
                  <div v-if="props.column.field == 'action'">
                    <template v-if="canEditWorkOrder == true && props.row.status.toLowerCase() != 'approved' && (props.row.po_status != 'closed' || props.row.wo_type != 'multi unit')">
                        <router-link title="Edit Work Order" class="fp-edit" v-bind:to="{name: 'WorkOrderEdit',params:{id:props.row.id},query:{from:'assetView',fromUrl:fromUrl}}"></router-link>
                    </template>
                    <template v-if="canViewWorkOrder == true && props.row.wo_type == 'warranty'">
                        <router-link title="View Work Order" class="ml-3 fp-view" v-bind:to="{name: 'WarrantyWorkOrderView',params:{id:props.row.id}}"></router-link>
                    </template>
                    <template v-if="canViewWorkOrder == true && props.row.wo_type != 'warranty'">
                        <router-link title="View Work Order" class="ml-3 fp-view" v-bind:to="{name: 'WorkOrderView',params:{id:props.row.id},query:{from:'assetView',fromUrl:fromUrl}}"></router-link>
                    </template>
                  </div>
                  <div v-else-if="props.column.field == 'customer_unit'">
                    <span v-fp-html="props.formattedRow[props.column.field]"></span>
                  </div>
                  <div v-else>
                    {{props.formattedRow[props.column.field]}}
                  </div>
                </div>
              </template>
              <div slot="selected-row-actions">
                <!-- <template v-if="canCreateWorkOrderEstimate == true">
                  <button id="createWorkOrderEstimateBtn" v-on:click.prevent="createWorkOrderEstimate" class="btn btn-success waves-effect">Create Estimate</button>
                </template> -->
                <template v-if="work_order_value == true">
                    <button v-if="showDeleteButton" id="deleteWorkOrderBtn" v-on:click.prevent="workOrderDelete" class="btn btn-danger">Delete</button>
                </template>
              </div>
            </vue-good-table>
            <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange">
            </custom-pagination>
        </div>
      </template>
        <div id="page-content-wrapper" class="admin-content-area" v-else>
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Work Order List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <template v-if="canAddWorkOrder == true">
                            <router-link class="btn btn-primary" v-bind:to="{name: 'WorkOrderCreate'}" > <i class="fp-add"> </i> Add</router-link>
                        </template>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content work-order-list">

                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div v-if="noDisplayTab" id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                <button type="button" id="getopenPurchaseOrder" v-on:click="getOpenWorkOrder(this)" :class="'btn btn-secondary '+activeOpenWoTab"> Open </button>
                                <button v-if="canCloseWo || canApproveWo" type="button" id="getclosePurchaseOrder" v-on:click="getCloseWorkOrder(this)" :class="'btn btn-secondary '+activeCloseWoTab"> Closed </button>
                                <button v-if="canApproveWo || canCloseWo" type="button" id="getapprovePurchaseOrder" v-on:click="getApprovedWorkOrder(this)" :class="'btn btn-secondary '+activeApproveWoTab"> Approved </button>
                                <button v-if="canApproveWo || canCloseWo" type="button" id="getDeletedPurchaseOrder" v-on:click="getDeletedWorkOrder(this)" :class="'btn btn-secondary '+activeDeletedWoTab"> Deleted </button>
                                <button v-if="canApproveWo || canCloseWo" type="button" id="getAllWorkOrder" v-on:click="getAllWorkOrder(this)" :class="'btn btn-secondary '+ activeAllWoTab"> All </button>
                            </div>
                        </div>

                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'listWorkOrderTable'" ref="filterWorkOrderList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>

                        <!-- Display error message when wo not approved in case sub vendor invoice not approved or po is required -->
                        <div v-if="woSubMessage != ''" class="alert alert-danger fade show">
                            <button type="button" class="close close-alert" v-on:click="clearMessage($event,'sublet')">×</button>
                            <ul class="addmessage">
                                <li> Work order(s) {{woSubMessage}} have not been approved as sublet vendor invoice is not approved yet. </li>
                            </ul>
                        </div>
                        <div v-if="woPOMessage != ''" class="alert alert-danger fade show">
                            <button type="button" class="close close-alert" v-on:click="clearMessage($event,'po')" >×</button>
                            <ul class="addmessage">
                                <li> Work order(s) {{woPOMessage}} have not been approved as PO# is required for the customer.</li>
                            </ul>
                        </div>
                        <div v-if="wo_approve_limit != ''" class="alert alert-danger fade show">
                            <button type="button" class="close close-alert" v-on:click="clearMessage($event,'wo_approve_limit')" >×</button>
                            <ul class="addmessage">
                                <li> {{ wo_approve_limit }}</li>
                            </ul>
                        </div>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="bg-white data-table">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'listWorkOrders'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    id="userlistWorkTbl"
                                    ref="listWorkOrderTable"
                                    mode="remote"
                                    title="Work Orders"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false,
                                        }"
                                    :select-options="{
                                        enabled: work_order_value,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                        }"
                                    :search-options="{
                                        enabled: false,
                                        }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                        <div v-if="props.column.field == 'action'" class='text-center'>
                                            <template v-if="canEditWorkOrder == true && props.row.status.toLowerCase() != 'approved' && (props.row.po_status != 'closed' || props.row.wo_type != 'multi unit')">
                                                <router-link title="Edit Work Order" class="fp-edit" v-bind:to="{name: 'WorkOrderEdit',params:{id:props.row.id}}"></router-link>
                                            </template>
                                        </div>
                                        <div v-if="props.column.field == 'description'" style="white-space: normal;">
                                            {{props.row.description}}
                                        </div>
                                        <div v-else-if="props.column.field == 'work_order_no' && canViewWorkOrder === true" class='text-center'>
                                            <router-link v-if="props.row.wo_type == 'warranty'" title="View Work Order" class="color-blue"  v-bind:to="{name: 'WarrantyWorkOrderView',params:{id:props.row.id}}">{{props.row.work_order_no}}</router-link>
                                            <router-link v-if="props.row.wo_type != 'warranty'" title="View Work Order" class="color-blue"  v-bind:to="{name: 'WorkOrderView',params:{id:props.row.id}}">{{props.row.work_order_no}}</router-link>
                                        </div>

                                        <div v-else-if="props.column.field == 'unit_no'" class='text-center'>
                                            <template v-if="props.row.oos_veh_id != ''" >
                                            <router-link  title="View Asset Details" class="color-red" v-bind:to="{name: 'AssetView',params:{id:props.row.oos_veh_id}}">{{props.row.unit_no}}</router-link>
                                            </template>
                                            <template v-else>
                                                {{props.row.unit_no}}
                                            </template>

                                        </div>
                                        <div v-else-if="props.column.field == 'work_order_estimate_no' && canViewEstimateWorkOrder === true" class='text-center'>
                                            <template v-if="props.row.work_order_estimate_no != '-'">
                                                <router-link title="View Work Order Estimate" class="color-blue"  v-bind:to="{name: 'WorkOrderEstimateView',params:{id:props.row.estimate_work_order_id}}">{{props.row.work_order_estimate_no}}</router-link>
                                            </template>
                                            <template v-else>
                                                {{props.row.work_order_estimate_no}}
                                            </template>
                                        </div>
                                        <div v-else-if="props.column.field == 'purchase_order_no' && canViewCustomerPurchaseOrder === true" class='text-center'>
                                            <template v-if="props.row.purchase_order_no != '-' && props.row.purchase_order_no != ''">
                                                <!-- <router-link title="View Purchase Order" class="color-blue"  v-bind:to="{name: 'CustomerPurchaseOrderView',params:{id:props.row.customer_purchase_order_id}}">{{props.row.purchase_order_no}}</router-link> -->
                                                {{props.row.purchase_order_no}}
                                            </template>
                                            <template v-else>
                                                {{props.row.purchase_order_no}}
                                            </template>
                                        </div>
                                        <div v-else-if="props.column.field == 'customer_unit'" class='text-center'>
                                            <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                        </div>
                                        <div v-else>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                        </div>
                                    </template>
                                    <div slot="selected-row-actions">
                                        <template v-if="work_order_value == true">
                                            <button v-if="showUpdateButton" id="copyWorkOrderBtn" v-on:click.prevent="showmodel" class="btn btn-primary">Update Po</button>
                                            <button v-if="canCopyWorkOrder" id="copyWorkOrderBtn" v-on:click.prevent="workOrderCopy" class="btn btn-primary">Copy</button>
                                            <button v-if="showDeleteButton" id="deleteWorkOrderBtn" v-on:click.prevent="workOrderDelete" class="btn btn-primary">Delete</button>
                                            <button v-if="showApproveButton && canApproveWo" id="approveWorkOrderBtn" v-on:click.prevent="workOrderApprove" class="btn btn-primary">Approve</button>
                                            <button v-if="showReviewButton" id="reviewWorkOrderBtn" v-on:click.prevent="reviewWo" class="btn btn-primary">Review All</button>
                                        </template>
                                    </div>
                                    </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                        <div class="modal fade copy-workorder-modal" id="copy-workorder-modal" ref="copyWorkorderModal" data-backdrop="static" data-keyboard="false" aria-labelledby="copyWorkorderModal" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div :class="`loader${loaderClass}`" v-show="loadingModal"></div>
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Copy Work Order</h5>
                                        <button type="button" class="close" id="btnPaymentModalClose" v-on:click="hideCopyWOModal()">&times;</button>
                                    </div>
                                    <div class="modal-body">
                                        <div class="form-row">
                                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="woCopyForm">
                                                <div class="col-sm-6 form-group">
                                                    <label class="control-label" for="wo_no">Copy From Work Order:</label>
                                                    <span>{{copyWONo}}</span>
                                                </div>
                                                <div class="col-sm-6 form-group">
                                                    <label class="control-label" for="wo_no_date">Opened:</label>
                                                    <span>{{copyWOOpenDt}}</span>
                                                </div>
                                                <!-- <div class="col-sm-6 form-group">
                                                    <label class="control-label require" for="newWoNo">New WO#:</label>
                                                    <input type="text" disabled class="form-control" v-model="newWoNo" id="new_wo_num" placeholder="Work Order No." name="new_wo_num" @keypress="isNumberCheck($event)">
                                                    <div class="field-error">{{ newWoNoErrMsg }}</div>
                                                </div> -->
                                                <div class="col-sm-6 form-group">
                                                    <label class="control-label" for="wo_new_open_date">Open Date for New Work Order:</label>
                                                    <div class="input-group">
                                                        <date-picker placeholder="MM/DD/YYYY HH:MM:SS" id="wo_new_open_date" name="wo_new_open_date" v-model="wo_new_open_date" :config="optionsWODate" aria-describedby="basic-addon3" class='cal-icon'></date-picker>
                                                        <label for="wo_new_open_date" class="fp-calendar input-calender-icon"></label>
                                                    </div>
                                                </div>

                                                <div class="col-sm-6 form-group"></div>
                                                <template v-if="copy_wo_type == 'default' && sectionsArr && sectionsArr.length">
                                                    <div class="col-sm-6 form-group">
                                                        <label class="control-label" for="wo_readings">Readings:</label>
                                                        <template v-for="(sec,scval) in sectionsArr">
                                                            <div class="form-group" :key="scval">
                                                                <template v-if="sec.section_code.toLowerCase() == 'dist'">
                                                                    <label class="control-label required" for="notes">Odometer:</label>
                                                                    <input type="text" class="form-control" v-model="sec.reading" :id="'wo_reading'+scval" autocomplete="off" :placeholder="'Odometer'" name="miles" @keypress="isAmountCheck($event)">
                                                                </template>
                                                                <template v-else>
                                                                    <label class="control-label required" for="notes">{{sec.sectionName}}:</label>
                                                                    <input type="text" class="form-control" v-model="sec.reading" :id="'wo_reading'+scval" autocomplete="off" :placeholder="sec.sectionName" name="miles" @keypress="isAmountCheck($event)">
                                                                </template>
                                                                <div class="field-error">{{ sec.reading_error }}</div>
                                                            </div>
                                                        </template>
                                                    </div>
                                                </template>
                                                <!-- <div class="col-sm-6 form-group"></div>
                                                <div class="col-sm-6 form-group">
                                                    <label class="control-label" for="wo_readings">Readings:</label>
                                                    {{sectionsArr}}
                                                </div> -->
                                                <div class="col-sm-12 form-group">
                                                    <span>Copy materials that were requisitioned on the original Work Order?</span>
                                                    <div class="form-group">
                                                        <label class="control-label" for="part_detail">Copy Parts Detail:</label>
                                                        <div class="custome-radiobtn form-check-inline">
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="copy_parts"> Yes
                                                                    <input type="radio" v-model="copy_parts" :value="1" id="copy_parts" name="copy_parts">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="copy_parts"> No
                                                                    <input type="radio" v-model="copy_parts" :value="0" id="copy_parts" name="copy_parts">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <span> Note: Core parts are not copied</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-sm-12 form-group">
                                                    <span>Is the new Work Order being created to reverse the original Work Order?</span>
                                                    <div class="form-group">
                                                        <label class="control-label" for="credit_wo">Create a Credit WO:</label>
                                                        <div class="custome-radiobtn form-check-inline">
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="credit_wo"> Yes
                                                                    <input type="radio" v-model="credit_wo" :value="1" id="credit_wo" name="credit_wo">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="credit_wo"> No
                                                                    <input type="radio" v-model="credit_wo" :value="0" id="credit_wo" name="credit_wo">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="form-group">
                                                        <label class="control-label" for="another_customer">Create 2nd copy to another customer:</label>
                                                        <div class="custome-radiobtn form-check-inline">
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="another_customer1"> Yes
                                                                    <input type="radio" v-model="another_customer" :value="1" id="another_customer1" name="another_customer1">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="another_customer2"> No
                                                                    <input type="radio" v-model="another_customer" :value="0" id="another_customer2" name="another_customer2">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12 form-group">

                                                            <v-select v-if="another_customer == '1'" v-model="anotherCustId" name="customer_id"
                                                                    label="text" :filterable="false" :options="customerArr"
                                                                    @search="onSearchCustomer"
                                                                    placeholder="Select Customer" class="col-sm-6  custom-ci-auto-search">
                                                                <template slot="no-options">
                                                                    Search Customer...
                                                                </template>
                                                                <template slot="option" slot-scope="option">
                                                                    <div class="d-center">
                                                                    {{ option.text }}
                                                                    </div>
                                                                </template>
                                                                <template slot="selected-option" slot-scope="option">
                                                                    <div class="selected d-center">
                                                                    {{ option.text }}
                                                                    </div>
                                                                </template>
                                                            </v-select>
                                                            <div class="field-error">{{ anotherCustIdErr }}</div>
                                                        </div>
                                                </div>
                                                <div class="col-sm-12 form-group">
                                                    <span>Create a sublet PO if the lines on the original Work Order were sublet?</span>
                                                    <div class="form-group">
                                                        <label class="control-label" for="sublet_po_detail">Sublet PO Detail:</label>
                                                        <div class="custome-radiobtn form-check-inline">
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="sublet_po_detail"> Yes
                                                                    <input type="radio" v-model="sublet_po_detail" :value="1" id="sublet_po_detail" name="sublet_po_detail">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="sublet_po_detail"> No
                                                                    <input type="radio" v-model="sublet_po_detail" :value="0" id="sublet_po_detail" name="sublet_po_detail">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <div class="col-sm-12 form-group">
                                                    <span>Copy Work Order Comments?</span>
                                                    <div class="form-group">
                                                        <label class="control-label" for="wo_comment">Copy WO Comments:</label>
                                                        <div class="custome-radiobtn form-check-inline">
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="copy_wo_comments"> Yes
                                                                    <input type="radio" v-model="copy_wo_comments" :value="1" id="copy_wo_comments" name="copy_wo_comments">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="copy_wo_comments"> No
                                                                    <input type="radio" v-model="copy_wo_comments" :value="0" id="copy_wo_comments" name="copy_wo_comments">
                                                                    <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->
                                                <div class="col-sm-12 form-group">
                                                    <label class="control-label" for="part_detail">Notes:</label>
                                                    <span>Only estimated hours are created. When reversing, actual hours are used for the new WO; otherwise, the estimated
                                                        hours are used.</span>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button class="btn btn-primary" id="btnPaymentModalProcess" v-on:click.prevent="createCopyWO()"> Confirm </button>
                                        <button class="btn btn-tertiary" id="btnPaymentModalCancel" v-on:click.prevent="hideCopyWOModal()"> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal fade updatepo" :id="'updatepo'" :ref="'updatepo'" data-backdrop="static" data-keyboard="false" aria-labelledby="selectDate" aria-hidden="true">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Update Customer PO</h5>
                                    </div>
                                    <div class="modal-body">
                                        <div class="form-row" >
                                            <div class="col-sm-6 form-group">
                                                <label class="control-label"  for="specialUnitDetail">Customer PO:</label>
                                                <input class="form-control" type="text" v-model="update_Cus_Po" id="updatecuspo" name="updatecuspo"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" id="btnPOModalAdd" class="btn btn-primary"  v-on:click.prevent="updateCusPo" >
                                        <i class="fp-save"> </i>  Save
                                        </button>
                                        <button type="button" class="btn btn-tertiary" id="cancelRecallAssetBtn" data-dismiss="modal"> <i class="fp-close"></i>Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
import EventBus from "./event-bus";


    export default {
        name: "WorkOrderList",
        mixins:[commonMixins,dataTableMixins],
        props: {
            workOrderVal: {
                type: String,
                required: false,
                default: undefined
            }
        },
        data: () => ({

            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            anotherCustId:"",
            anotherCustIdErr:"",
            customerArr:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    hidden: false,
                },
                {
                    label: '#WO',
                    field: 'work_order_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Work Order No", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" ,//only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Notes',
                    field: 'description',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "description", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" ,//only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Has Sublet',
                    field: 'sublet_item',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '',
                        filterDropdownItems:['Yes','No'], // initial populated value for this filter
                        trigger: "enter" ,//only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Has Billable',
                    field: 'has_billable',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '',
                        filterDropdownItems:['Yes','No'], // initial populated value for this filter
                        trigger: "enter" ,//only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Has Warranty',
                    field: 'has_warranty',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '',
                        filterDropdownItems:['Yes','No'], // initial populated value for this filter
                        trigger: "enter" ,//only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Unit',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit No.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Customer Unit',
                    field: 'customer_unit',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer Unit.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html: true
                },
                {
                    label: 'Customer Unit No',
                    field: 'alias_number',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Alias Number.", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html: true
                },
                {
                    label: 'Customer',
                    field: 'customer_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Program',
                    field: 'program',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Program", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'User',
                    field: 'user_id',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "User", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Open Date',
                    field: 'open_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Priority',
                    field: 'priority',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Priority", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterDropdownItems: ['Open','In Progress' ,'Review', 'Closed','Approved'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Approved By',
                    field: 'approved_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Approved By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                  label: 'Deleted By',
                  field: 'deleted_by',
                  fpFieldType:"text",
                  filterable: true,
                  hidden:true,
                  filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Deleted By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                  }
                },
                {
                    label: 'VIN',
                    field: 'vin_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden: false,
                    filterOptions: {
                        enabled: false,
                        placeholder: "VIN No",
                        filterValue: '',
                        trigger: "enter" ,
                    }
                },
            ],
            action:'',
            rows: [],
            totalRecords: 0,
            work_order_value: false,
            vehicle_id:"",
            loading:false,
            costCodeArr:[],
            canEditWorkOrder: false,
            canViewWorkOrder: false,
            canAddWorkOrder: false,
            canCreateWorkOrderEstimate: false,
            canViewEstimateWorkOrder: false,
            canViewCustomerPurchaseOrder: false,
            idArr:"",
            pageKey:"_work_order_list_",
            showDeleteButton:false,
            showApproveButton:false,
            showUpdateButton:false,
            showReviewButton:false,
            // showApproveBtn:false,
            fromUrl:"",
            activeOpenWoTab:'',
            activeCloseWoTab:'',
            activeApproveWoTab:'',
            activeAllWoTab:'',
            selectedStatus:'open',
            role: '',
            displayAllTab: false,
            displayOpenAndClose: false,
            noDisplayTab: false,
            canApproveWo:false,
            woSubMessage:"",
            wo_approve_limit:"",
            woPOMessage:"",
            batchProcess:0,
            batchNum:"",
            canCopyWorkOrder:false,
            copyWOId:"",
            copyWONo:"",
            copyWOOpenDt:"",
            wo_new_open_date:"",
            optionsWODate: {
                format: 'MM/DD/YYYY hh:mm:ss a',
                useCurrent: false,
                showClose: true,
            },
            copy_parts:0,
            credit_wo:0,
            another_customer:0,
            sublet_po_detail:0,
            copy_wo_comments:0,

            sectionsArr:[],
            loadingModal:false,
            copy_wo_type:'',
            canCloseWo:false,
            newWoNo:"",
            newWoNoErrMsg:"",
            update_Cus_Po:0,
            activeDeletedWoTab: "",
            hideAction: false,
            showDeletedBy: true,
        }),
        metaInfo () {
            if (this.workOrderVal == undefined) {
                return {
                    title: "Work Order List | " +process.env.COPYRIGHT_NAME
                }
            }
        },
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_work_order') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_work_order') {
                            self.canAddWorkOrder = true;
                            self.canEditWorkOrder = true;
                        }
                        if (permissions[i].name == 'delete_work_order') {
                            self.work_order_value = true;
                        }
                        if (permissions[i].name == 'view_work_order') {
                            self.canViewWorkOrder = true;
                        }
                        if (permissions[i].name == 'can_approve_work_order') {
                            //self.displayAllTab = true;
                            self.canApproveWo = true;
                            self.noDisplayTab = true;
                        }
                        if (permissions[i].name == 'can_close_work_order') {
                            //self.displayAllTab = true;
                            self.canCloseWo = true;
                            self.noDisplayTab = true;
                        }

                        // For technician
                        if (permissions[i].name == 'update_assigned_work_order') {
                            self.canEditWorkOrder = true;
                        }

                        if (permissions[i].name == 'can_create_work_order_estimate') {
                            self.canCreateWorkOrderEstimate = true;
                        }

                        if (permissions[i].name == 'view_customer_estimate') {
                            self.canViewEstimateWorkOrder = true;
                        }
                        if (permissions[i].name == 'view_customer_purchase_order') {
                            self.canViewCustomerPurchaseOrder = true;
                        }
                        if (permissions[i].name == 'copy_work_order') {
                            self.work_order_value = true;
                            self.canCopyWorkOrder = true;
                        }

                    }
                }

            }

        },
        created: function() {

        },
        beforeDestroy(){
            this.$root.$off('work_order');
        },
        mounted: function() {
            var self = this;

            if (self.workOrderVal == undefined){
                self.getPermissions();
            }

            var userObj = JSON.parse(localStorage.getItem("user_obj"));

            if (userObj != null) {

                if (userObj.roles.length > 0) {

                    for ( var i = 0; i < userObj.roles.length; i++ ) {
                        if (userObj.roles[i].name == 'technician') {
                            //self.noDisplayTab = false;
                            self.role = userObj.roles[i].name.toLowerCase();
                        }
                        //checking by permissions instead of roles
                        // else if (userObj.roles[i].name =='service manager') {
                        //     self.noDisplayTab = true;
                        //     self.displayAllTab = true;
                        // } else {
                        //     self.noDisplayTab = true;
                        //     self.displayAllTab = true;
                        // }

                    }

                }
            }
            self.fromUrl = btoa(window.location.pathname);


            // when user came back from other page this will load the same tab selected before
            $('#divTabMenu button').removeClass("active");
            var prevSelectedTab = localStorage.getItem("wo_list_prev_tab");

            if ( prevSelectedTab == null ) {

                self.selectedStatus = "open";
                self.activeOpenWoTab = 'active';
                localStorage.setItem('wo_list_prev_tab', 'open_tab');

            } else {

                if ( prevSelectedTab == 'all_tab' ) {

                    self.selectedStatus = "all";
                    self.activeAllWoTab = 'active';

                } else if ( prevSelectedTab == 'close_tab' ) {

                    self.selectedStatus = "close";
                    self.activeCloseWoTab = 'active';

                } else if ( prevSelectedTab == 'approve_tab' ) {

                    self.selectedStatus = "approved";
                    self.activeApproveWoTab = 'active';

                } else if ( prevSelectedTab == 'deleted_tab'){
                  self.selectedStatus = "deleted";
                  self.activeDeletedWoTab = 'active';
                } else {

                    self.selectedStatus = "open";
                    self.activeOpenWoTab = 'active';
                }
            }

            //when component list directly call from url instead of in view page than call permission request
            if ( self.workOrderVal == undefined ) {

                setTimeout(function() {

                    // self.openWorkOrder = 'active';
                    // self.activeCloseWoTab = false;
                    // self.selectedStatus = "open";
                }, 1000);

            }else{

                self.selectedStatus = "";
                var path = window.location.pathname;
                var segments = path.split("/");
                self.workOrderVal = "loadList";

                self.loadList();
            }

        },
        methods: {

            onSearchCustomer(search, loading) {
                var self = this;
                if (search.length > 2) {
                    loading(true);
                    self.searchField(loading, search, 'customer', '');
                }
            },

            clearMessage: function(evt,action) {
                var self = this;
                evt.target.parentElement.classList.remove("show");
                if ( action == "sublet" ) {
                    self.woSubMessage = '';
                } else if(action== "wo_approve_limit"){
                    self.wo_approve_limit = '';
                }else {
                    self.woPOMessage = '';
                }
            },
            getOpenWorkOrder: function() {

                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getopenPurchaseOrder").addClass("active");
                self.$refs.filterWorkOrderList.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                localStorage.setItem('wo_list_prev_tab', 'open_tab');
                self.selectedStatus = "";
                self.$nextTick(() => {
                  // Add the component back in
                  self.selectedStatus = "open";
                  self.loadList();
                });
            },
            getCloseWorkOrder: function(){

                var self = this;
                self.$refs.filterWorkOrderList.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                $('#divTabMenu button').removeClass("active");
                $("#getclosePurchaseOrder").addClass("active");
                localStorage.setItem('wo_list_prev_tab', 'close_tab');
                self.selectedStatus = "";
                self.$nextTick(() => {
                  // Add the component back in
                  self.selectedStatus = "close";
                  self.hideAction = false;
                  self.showDeletedBy = true;
                  self.loadList();
                });
            },
            getApprovedWorkOrder: function(){

                var self = this;
                self.$refs.filterWorkOrderList.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                $('#divTabMenu button').removeClass("active");
                $("#getapprovePurchaseOrder").addClass("active");
                localStorage.setItem('wo_list_prev_tab', 'approve_tab');
                self.selectedStatus = "";
                self.$nextTick(() => {
                  // Add the component back in
                  self.selectedStatus = "approved";
                  self.hideAction = false;
                  self.showDeletedBy = true;
                  self.loadList();
                });
            },
            getDeletedWorkOrder: function(){
              var self = this;
              self.$refs.filterWorkOrderList.clearSelectAll();
              EventBus.$emit('clear-all-flags', false);
              $('#divTabMenu button').removeClass("active");
              $("#getDeletedPurchaseOrder").addClass("active");
              localStorage.setItem('wo_list_prev_tab', 'deleted_tab');
              self.selectedStatus = "";
              self.$nextTick(() => {
                // Add the component back in
                self.selectedStatus = "deleted";
                self.hideAction = true;
                self.showDeletedBy = false;
                self.loadList();
              });
            },
            getAllWorkOrder: function(){

                var self = this;
                self.$refs.filterWorkOrderList.clearSelectAll();
                EventBus.$emit('clear-all-flags', false);
                $('#divTabMenu button').removeClass("active");
                $("#getAllWorkOrder").addClass("active");
                localStorage.setItem('wo_list_prev_tab', 'all_tab');
                self.selectedStatus = "";
                self.$nextTick(() => {
                    // Add the component back in
                    self.selectedStatus = "all";
                    self.hideAction = false;
                    self.showDeletedBy = true;
                    self.loadList();
                });
            },
            cancelAll: function (cancelAll) {
              this.$refs.listWorkOrderTable.unselectAllInternal();
            },
            workOrderApprove() {
                var data = this.$refs['listWorkOrderTable'].selectedRows;
                var self = this;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listWorkOrderTable'].selectedRows[i].id)
                }
                self.idArr = use;
                self.action = "approve";
                if (confirm('Are you sure that you want to approve this Work Order? ')) {

                    self.loadList();

                }

            },

            loadList(action1 = '') {

                var self = this;
                self.woPOMessage = '';
                self.wo_approve_limit = '';
                self.woSubMessage = '';
                var use = [];
                self.loading = true;

                var path = window.location.pathname;
                var segments = path.split("/");
                var data = this.$refs['listWorkOrderTable'].selectedRows;


                if( self.workOrderVal == 'dontLoadList' ){
                    return;
                }

                if ( self.action=='delete' ) {
                    $("#deleteWorkOrderBtn").val("Deleting ...");
                }

                //if action is not reset then only
                if ( action1 != "clear" ) {
                    for ( var i = 0; i < data.length; i++ ) {
                        use.push(this.$refs['listWorkOrderTable'].selectedRows[i].id)
                    }
                }

                var fields = {
                    vehicle_id:segments[3],
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    flag: self.action,
                    all:self.serverParams.selectedAll,
                    sort: self.serverParams.sort,
                    id:self.idArr,
                    action:action1,
                    selectedRows:use,
                    status:self.selectedStatus,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/workorder/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);

                        if (data.status == "success") {

                            if ( self.action=='delete') {
                                self.action = "";
                                if (self.workOrderVal == undefined)
                                {
                                    self.$refs.filterWorkOrderList.clearSelectAll();
                                    EventBus.$emit('clear-all-flags', false);
                                }

                                if (data.code == '200') {
                                    self.loadList();
                                    //EventBus.$emit('clear-all-flags', false);   //hide alert of selection
                                    return;
                                }

                            }else if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                // self.loadList();
                            } else if ( self.action == 'approve' ) {
                                console.log('response=>',data.unapproved_wo)
                                self.action = 'list';
                                if ( data.code == "201" ) {
                                    if ( data.wo_arr != "" ) {
                                        self.woSubMessage = data.wo_arr;
                                    }
                                    if ( data.wo_req_po != "" ) {
                                        self.woPOMessage = data.wo_req_po;
                                    }
                                    if ( data.wo_num != "" ) {
                                        self.wo_approve_limit = 'Wo approve limit exeeds for the WO ' + data.wo_num + '. which is more than ' + data.user_wo_approval_limit;
                                    }

                                } else {

                                    if ( data.unapproved_wo.length > 0 ) {

                                        var unapprovedWos = data.unapproved_wo.join();
                                        var msg = "These work order have not been approved because they have open work order line items: " + unapprovedWos;
                                        self.$swal('',msg,'success');

                                    }
                                    self.getCloseWorkOrder();
                                    return;
                                }

                            } else  {
                                console.log(self.columns);
                                self.columns[0]['hidden'] = self.hideAction;
                                self.columns[17]['hidden'] = self.showDeletedBy;
                                self.columns[17]['filterable'] = self.hideAction;
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;

                                self.$refs.filterWorkOrderList.clearSelectAll();
                                EventBus.$emit('clear-all-flags', false);

                                //

                                for (var i = 0; i < self.columns.length; i++) {
                                    if (self.columns[i].field == 'cost_code') {
                                        console.log(data.costCodes)
                                        self.columns[i].filterOptions.filterDropdownItems = data.costCodes;
                                    }
                                }
                            }


                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if(self.action=='delete') {
                            self.generateStatusCodeMessage(jqXHR,false,'wodelete')
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'wolist')
                        }

                    }
                });
            },

            workOrderDelete() {
                var data = this.$refs['listWorkOrderTable'].selectedRows;
                var self = this;
                var use = [];
                var haveProgram = '';
                for (var i = 0; i < data.length; i++) {
                    console.log(data[i].program);
                    if (data[i].program && data[i].program != null && data[i].program != '' && data[i].program != undefined){
                        // haveProgram.push(data[i].work_order_no);
                        if (haveProgram == ''){
                            haveProgram = data[i].work_order_no;
                        }else{
                            haveProgram += ' | '+data.work_order_no;
                        }
                    }
                    use.push(this.$refs['listWorkOrderTable'].selectedRows[i].id)
                }
                // console.log(haveProgram);
                self.idArr=use;
                self.action="delete";
                    if (haveProgram != ''){
                        self.$swal({
                        title: "Reschedule the program?",
                        text: haveProgram+' These work have program attached',
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes",
                        cancelButtonText: "Skip",
                        showCloseButton: true,
                        showLoaderOnConfirm: false,
                        allowOutsideClick:false
                    }).then(result => {
                        if (result.value) {
                            self.loadList('reset');
                        } else if (result.dismiss == 'cancel') {
                            self.loadList('skip');
                        }else if(result.dismiss == 'close'){
                            return;
                        }
                    });
                }else{
                  self.$swal({
                        title: 'Are you sure that you want to delete this Work Order?',
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        showCloseButton: false,
                        showLoaderOnConfirm: true
                    }).then((result) => {
                        if (result.value) {
                          self.loadList();
                        } else {
                          console.log("no");
                        }
                  });
                    // if (confirm('Are you sure that you want to delete this Work Order? ')) {

                    //     self.loadList();

                    // }
                }


            },

            createWorkOrderEstimate() {

                var self = this;

                if ( this.$refs['listWorkOrderTable'].selectedRows.length != 1 ) {
                    self.$swal('',"Kindly choose only one work order.",'info');
                    return;
                }

                if ( this.$refs['listWorkOrderTable'].selectedRows[0].work_order_estimate_no != '-' ) {
                    self.$swal('',"Estimate has already been created.",'info');
                    return;
                }

                if (confirm('A new work Order Estimte will create from selected work order ')) {
                    this.$router.push({ name: 'CustomerEstimateCreate', params:{workOrderId: this.$refs['listWorkOrderTable'].selectedRows[0].id, redirectFrom: 'WorkOrderList'}})
                }

            },
            exportCheck: function() {
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listWorkOrderTable'].selectedRows;
                count = data.length;
                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }
                this.exportReports(actionFlag);
            },
            selectionChanged(param) {
                var self = this;

                var rowData = self.$refs['listWorkOrderTable'].selectedRows;
                var selectedStatusArr = [];
                var selecteddeleteStatusArr = [];
                self.showDeleteButton = true;
                self.showReviewButton = false;
                self.showApproveButton = false;
                self.showUpdateButton = false;

                if(rowData.length > 0){

                    for(var i = 0;i<rowData.length;i++){
                        selectedStatusArr.push(rowData[i].status.toLowerCase());
                    }

                    if (selectedStatusArr.includes("approved")) {
                        self.showDeleteButton = false;
                    }
                    if (selectedStatusArr.includes("closed")) {
                        self.showApproveButton = true;
                        self.showReviewButton = true;
                    }
                    if(!selectedStatusArr.includes("approved")){
                        self.showUpdateButton = true;
                    }
                    for(var i = 0;i<rowData.length;i++){
                        if(rowData[i].deleteflag != null && rowData[i].deleteflag != ''){
                            selecteddeleteStatusArr.push(rowData[i].deleteflag.toLowerCase());
                        }
                    }
                }

                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
            },
            reviewWo : function(){
                var self = this;
                var selectedRows = [];
                var rowData = self.$refs['listWorkOrderTable'].selectedRows;

                for ( var i = 0; i < rowData.length; i++ ) {
                    if (rowData[i].status == 'Closed'){
                        selectedRows.push(rowData[i].id);
                    }
                }
                if (selectedRows.length > 0){
                    self.storeWOBatch(selectedRows);
                }else{
                    self.$swal('','No open work order found','info');
                }
            },
            storeWOBatch:function(idArr){
                var self = this;

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/wo-batch/store",
                    type: "POST",
                    data: {
                        ids:idArr
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.$router.push('/workorder/view/'+data.content.id+'?batch='+data.content.batch);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'wo-batch-list');

                    }
                });
            },
            workOrderCopy() {
                var self = this;
                if ( this.$refs['listWorkOrderTable'].selectedRows.length != 1 ) {
                    self.$swal('',"Kindly choose only one work order.",'info');
                    return;
                }
                var woDataArr = this.$refs['listWorkOrderTable'].selectedRows;
                if (woDataArr[0].id != undefined && woDataArr[0].id != null) {
                    self.copyWOId = woDataArr[0].id;
                    if (self.copyWOId != "") {
                        self.loading = true;
                        $.ajax({
                            url: process.env.ROOT_API + "/workorder/get-wo-info",
                            type: "GET",
                            headers: this.ajxHeaders,
                            dataType: "json",
                            data: {'wo_id':self.copyWOId},
                            success: function (data) {
                                self.loading = false;
                                if (data.status == "success") {
                                    self.sectionsArr = [];
                                    self.copy_wo_type = '';

                                    self.copyWONo = data.content.work_order_no;
                                    self.copy_wo_type = data.content.wo_type;
                                    if (data.content.open_date != null && data.content.open_date != "") {
                                        self.copyWOOpenDt = data.content.open_date;
                                        self.wo_new_open_date = data.content.open_date;
                                    }
                                    if (data.content.sectionData != undefined){
                                        self.sectionsArr = data.content.sectionData;
                                    }else{
                                        self.sectionsArr = [];
                                    }
                                    //self.getWorkOrderNo();
                                    //open copy work order options model
                                    $("#copy-workorder-modal").modal("show");

                                }
                            },
                            error: function (jqXHR, exception) {
                                self.loading = false;
                                self.generateStatusCodeMessage(jqXHR, false, 'get-workorder-details');
                            }
                        });

                    }
                }
            },
            getWorkOrderNo(){
                var self = this;
                $.ajax({
                            url: process.env.ROOT_API + "/workorder/number",
                            type: "POST",
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                self.loading = false;
                                if (data.status == "success") {
                                    self.newWoNo = data.content.work_order_no;
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.loading = false;
                                self.generateStatusCodeMessage(jqXHR, true, 'get-workorder-number');
                            }
                        });
            },
            createCopyWO() {

                var self = this;
                self.newWoNoErrMsg = "";
                self.anotherCustIdErr = "";
                var workOrderError = "";
                var error = false;


                // workOrderError = self.validateLength(self.newWoNo, 8, 12);
                // if (workOrderError) {
                //     self.newWoNoErrMsg = workOrderError;
                //     error = true;
                // }
                // if ( self.newWoNo == "" || self.newWoNo == null ) {
                //     self.newWoNoErrMsg = "Please enter work order no.";
                //     error = true;
                // }
                if ( self.another_customer == 1 && self.anotherCustId == '') {
                    self.anotherCustIdErr = "Please select customer";
                    error = true;
                }

                if ( error == true ) {
                    return;
                }

                var fields = $("#woCopyForm").serializeArray();
                fields.push({
                    name: "wo_id",
                    value: self.copyWOId
                });
                // fields.push({
                //     name: "new_wo_no",
                //     value: self.newWoNo
                // });
                fields.push({
                    name: "reading",
                    value: JSON.stringify(self.sectionsArr)
                });
                fields.push({
                    name: "from",
                    value: "copy"
                });
                fields.push({
                    name: "id",
                    value: ""
                });
                fields.push({
                    name: "another_customer",
                    value: self.another_customer
                });

                if ( self.another_customer == 1 ) {
                    fields.push({
                        name: "customer_id",
                        value: self.anotherCustId.value
                    });
                }

                self.loadingModal = true;
                $.ajax({
                    url: process.env.ROOT_API + "/workorder/copy",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loadingModal = false;
                        if (data.status == "success") {
                            if (data.content.id != undefined && data.content.id != null) {
                                $("#copy-workorder-modal").modal("hide");
                                self.$router.push({name: 'WorkOrderView',params:{id:data.content.id,from:'copy'}});
                            }else{
                                self.$swal('',data.message,'info');
                            }
                        }else{
                            self.$swal('',data.message,'info');
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loadingModal = false;
                        self.generateStatusCodeMessage(jqXHR, true, 'copy-work-order');
                    },
                });
            },
            hideCopyWOModal() {
                var self = this;
                $("#copy-workorder-modal").modal("hide");
                self.sectionsArr = [];
                self.copyWOId = "";
                self.copyWONo = "";
                self.copyWOOpenDt = "";
                self.wo_new_open_date = "";
                self.new_wo_num = "";
                self.copy_parts = 0;
                self.credit_wo = 0;
                self.another_customer = 0;
                self.sublet_po_detail = 0;
                self.copy_wo_comments = 0;
            },
            showmodel(){
                $("#updatepo").modal("show");
            },
            updateCusPo(){
                var self = this;
            $("#btnPOModalAdd").text("Saving ...");
            $("#btnPOModalAdd").prop("disabled", true);
            self.loading =  true;
            var work_order_id_arr = [];
            var data = this.$refs['listWorkOrderTable'].selectedRows;
            for (var i = 0;i < data.length;i++) {
                if (data[i] != undefined) {
                    if (data[i] != null) {
                        if (data[i].id != undefined && data[i].id != null) {
                            work_order_id_arr.push(data[i].id);
                        }
                    }
                }
            }

            $.ajax({
                url: process.env.ROOT_API + "/customerpo/update",
                type: "POST",
                crossDomain: true,
                headers: this.ajxHeaders,
                dataType: "json",
                data:{
                    work_order_id_arr:work_order_id_arr,
                    update_Cus_Po:self.update_Cus_Po,
                },
                success: function (data) {
                    self.loading =  false;
                    $("#btnPOModalAdd").text("Save");
                    $("#btnPOModalAdd").prop("disabled", false);
                    if (data.status == "success") {
                        $("#updatepo").modal("hide");
                        self.$swal('',data.message,'success');
                    }else{
                        self.$swal('',data.message,'info');
                    }
                    self.loadList();

                },
                error: function (jqXHR, exception) {
                    $("#btnPOModalAdd").text("Save");
                    $("#btnPOModalAdd").prop("disabled", false);
                    self.loading =  false;
                    $("#updatepo").modal("hide");
                    self.generateStatusCodeMessage(jqXHR, false, 'close-wo-items');
                    self.loadList();
                }
            });
            },
            isNumberCheck: function (evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if (charCode === 45 && evt.target.value.split('-').length > 1) {
                    evt.preventDefault();
                }
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1) && charCode !== 44 && charCode !== 45) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/WorkOrderList.vue